import React, { FC, useContext } from 'react';
import { Typography, useTheme } from '@mui/material';
import './survey_progress.css';
import { useTranslation } from 'react-i18next';
import { LocalTranslationContext } from '../../hooks/useLocalTranslation';

interface Props {
  currentPage: number;
  numPages: number;
  language: string;
  introDisabled?: boolean;
}
export const SurveyProgress: FC<Props> = ({ currentPage, numPages, introDisabled }) => {
  let shownNumPages, shownCurrentPage;
  if (introDisabled) {
    shownNumPages = numPages;
    shownCurrentPage = currentPage;
  } else {
    shownNumPages = numPages + 1;
    shownCurrentPage = currentPage + 1;
  }
  const progress = shownCurrentPage / shownNumPages;
  const theme = useTheme();

  const localContext = useContext(LocalTranslationContext);
  const { t: globalT } = useTranslation('customSurvey');
  const t = localContext ? localContext.t : globalT;

  if (currentPage < 0) {
    return <></>;
  }

  return (
    <>
      <span
        className={'survey-progress-outer'}
        style={
          {
            '--inner-progress-bar-color': theme.palette.primary.main,
          } as React.CSSProperties
        }
      >
        <span
          className={'survey-progress-inner'}
          style={{
            width: Math.round(progress * 100) + '%',
          }}
        >
          <span className={'survey-progress-label'}>{Math.round(progress * 100)} %</span>
        </span>
      </span>
      {currentPage < numPages && (
        <Typography>
          {t('question_n_out_of_n', {
            currentPage: shownCurrentPage + 1,
            numPages: shownNumPages + 1,
          })}
        </Typography>
      )}
    </>
  );
};
